// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__2nyB4","checkboxCol":"Table_checkboxCol__2lHqc","emailCol":"Table_emailCol__1fX-U","actionCol":"Table_actionCol__3HgAO"};